import { getShareFrom, getOriginFrom, getEntrySource } from 'ym-reporter-vue';
import request from '@/utils/request';

import { getYmDevice } from '@/utils';

export function getSkuData(targetType, targetId) {
  return request({
    url: '/Order/getSku',
    method: 'POST',
    data: {
      targetType,
      targetId,
    },
  });
}

export function getBenefit(targetId, targetType) {
  return request({
    url: '/Order/benefitShow',
    method: 'POST',
    data: {
      targetId,
      targetType,
    },
  });
}

export function calculatePrice(data) {
  return request({
    url: '/Order/calculateAmount',
    method: 'POST',
    data,
  });
}

export function createOrder(options) {
  const data = Object.assign({
    ymsf: getShareFrom(),
    origin: getOriginFrom(),
    ymDevice: getYmDevice(),
    entrySource: getEntrySource(),
  }, options);
  return request({
    url: '/Order/create',
    method: 'POST',
    data,
    toastMessage: false,
  });
}

export function checkCoupon(data) {
  return request({
    url: '/Order/checkCoupon',
    method: 'POST',
    data,
  });
}

export function getWeChatPayParams(sn, code = '', payActionSource) {
  return request({
    url: '/Order/weChatPayParams',
    method: 'POST',
    data: {
      sn,
      code,
      payActionSource,
    },
  });
}

export function getOrderStatus(sn, type) {
  return request({
    url: '/Order/status',
    params: {
      sn,
      type,
    },
    silentRequest: true,
  });
}

export function getGroupBuyNotify(sn) {
  return request({
    url: '/Order/notify',
    params: {
      sn,
    },
  });
}

export function getNotifyInfo(sn) {
  return request({
    url: '/Order/notify',
    params: {
      sn,
    },
  });
}

export function getMyOrderList(params, silentRequest = false) {
  return request({
    url: '/My/orders',
    params,
    silentRequest,
  });
}

export function getOrderDetail(sn, payActionSource) {
  return request({
    url: '/Order/detail',
    params: {
      sn,
      payActionSource,
    },
  });
}

export function cancelOrder(sn) {
  return request({
    url: '/Order/cancel',
    method: 'POST',
    data: {
      sn,
    },
  });
}

export function deleteOrder(sn) {
  return request({
    url: '/Order/delete',
    method: 'POST',
    data: {
      sn,
    },
  });
}

export function orderPreCheck(targetId, targetType, targetCount) {
  return request({
    url: '/Order/preCheck',
    params: {
      targetId,
      targetType,
      targetCount,
    },
  });
}


export function showPayCenter(targetId, targetType, targetCount, addressId) {
  return request({
    url: '/Order/showPayCenter',
    params: {
      targetId,
      targetType,
      targetCount,
      addressId,
    },
    toastMessage: false,
  });
}

export function getCoupons(data) {
  return request({
    url: '/Order/getCoupons',
    method: 'POST',
    data,
  });
}

export function getWeChatPayUrl(sn, payActionSource) {
  return request({
    url: '/Order/weChatPayUrl',
    method: 'POST',
    data: {
      sn,
      payActionSource,
    },
  });
}
